import CryptoJS from "crypto-js";
const key = CryptoJS.enc.Utf8.parse("812e37c17bd04de395ef397974e08a4b");
export function Decrtpt(value) {
  let src = CryptoJS.enc.Hex.parse(value);
  let decrypt = CryptoJS.AES.decrypt(
    {
      ciphertext: src
    },
    key,
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }
  );
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  let data = decryptedStr.toString() || value;
  return data;
}
export function Encrypt(value) {
  let encrypt = CryptoJS.AES.encrypt(value, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypt.toString();
}



// WEBPACK FOOTER //
// ./src/utils/crypto.js